import { render, staticRenderFns } from "./AddProjectToWorklistModal.vue?vue&type=template&id=0cf7f07c&scoped=true"
import script from "./AddProjectToWorklistModal.vue?vue&type=script&lang=js"
export * from "./AddProjectToWorklistModal.vue?vue&type=script&lang=js"
import style0 from "./AddProjectToWorklistModal.vue?vue&type=style&index=0&id=0cf7f07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7f07c",
  null
  
)

export default component.exports